module.exports = __webpack_public_path__ + "media/images/emblems/HauptwilGottshaus-blazon-a818e6a5d23412be78842e687e69e97e.svg";